import React from "react";

interface Props { title: string; value: string; subtitle?: string; className?: string; }

const CardTile: React.FC<Props> = ({ title, value, subtitle }) => {
  return (
    <div className="card p-3 tile-card">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <small className="text-muted">{title}</small>
          <div className="h4 mb-1 fw-bold">{value}</div>
          {subtitle && <small className="text-muted">{subtitle}</small>}
        </div>
        <div className="donut"><svg width="48" height="48"><circle cx="24" cy="24" r="18" stroke="#4f46e5" strokeWidth="8" fill="none" strokeDasharray="85 15" transform="rotate(-90 24 24)"/></svg></div>
      </div>
    </div>
  );
};

export default CardTile;
